import type { Enums } from "@msuite/utils/types";
import type { IconName } from "./icons";

export function getScopeIcon(scope: Enums<"scope">): IconName {
	switch (scope) {
		case "global":
			return "Globe";
		case "user":
			return "User";
		default:
			return "Box";
	}
}
